query estadoSelect {
    data: estados(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}